export class FlightOptionPreview {
  price: number;
  pax: number;
  aircraftId: number;
  model: string;
  category: string;
  img: string;
}
